<section class="vacancy-section position-relative py-5">
    <!-- Dark overlay for readability -->
    <div class="vacancy-overlay"></div>

    <div class="container-fluid px-lg-5 position-relative z-3 py-4">
        <div class="row align-items-center justify-content-between g-4">
            <!-- Left Text Column -->
            <div class="col-xl-8 col-lg-7 text-lg-start text-center animate-on-scroll fade-right">
                <h2 class="vacancy-title text-white">Like To Be The Part Of Vaish College Faculty!!!</h2>
                <p class="vacancy-desc text-white-50 mt-3 mb-0">
                    Vaish College always welcome to talented Mentor to share the podium for their students.
                </p>
            </div>

            <!-- Right Button Column -->
            <div class="col-xl-4 col-lg-5 text-lg-end text-center animate-on-scroll fade-left">
                <a class="btn-vacancy" href="mailto:info@vaishgirlscollege.com">
                    DROP YOUR CV NOW
                </a>
            </div>
        </div>
    </div>
</section>
